var styles = {"fontElementMap":"OLNqu","orderedlist":"fjRPV","bulletedlist":"tHwdu","listItem":"_6Ydq9"};

export { styles as s };
//# sourceMappingURL=lists-fe57af3e.js.map
